import msg from "components/string-table";
import { Section } from "main";

import styles from "./Education.module.css";

type EditableEducation =
  | {
      isEditable: false;
    }
  | {
      isEditable: true;
      onEditEducation: () => void;
    };

export type EducationProps = {
  editable?: EditableEducation;
  education?: { id: number; name: string }[];
};

export function Education(props: EducationProps) {
  const { editable, education } = props;

  return (
    <Section
      onEditClick={editable?.isEditable ? editable.onEditEducation : undefined}
      title={msg("SUB_PROFILE_EDUCATION_HEADER")}
    >
      <div>
        {education && education.length > 0 ? (
          <ul className={styles["list-wrapper"]}>
            {education.map((edu) => (
              <li key={edu.id} className={styles.list}>
                {edu.name}
              </li>
            ))}
          </ul>
        ) : (
          <span style={{ fontStyle: "italic" }}>
            {editable?.isEditable
              ? msg("SUB_PROFILE_EDUCATION_EDIT_EMPTY")
              : msg("SUB_PROFILE_NO_INFORMATION")}
          </span>
        )}
      </div>
    </Section>
  );
}
